import React from 'react';
import Badge from './Badge';
import Button from './Button';
import './VehicleCard.css';

function VehicleCard({ name, year, imageSrc, imageAlt, status, price, to }) {
  return (
    <article className="vehicle-card">
      {imageSrc ? (
        <img className="vehicle-card__image" src={imageSrc} alt={imageAlt} />
      ) : (
        <div className="vehicle-card__image vehicle-card__image--placeholder">
          Photos coming soon
        </div>
      )}
      <div className="vehicle-card__body">
        <div className="vehicle-card__heading">
          <h3 className="vehicle-card__name">
            {name}
            {year ? ` (${year})` : ''}
          </h3>
          <Badge status={status} />
        </div>
        <div className="vehicle-card__footer">
          <span className="vehicle-card__price">{price}</span>
          <Button variant="secondary" to={to} className="vehicle-card__link">
            View Details
          </Button>
        </div>
      </div>
    </article>
  );
}

export default VehicleCard;
